var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Transition", { attrs: { name: "fade" } }, [
    _c("div", { staticClass: "im-tag-container" }, [
      _c("div", { staticClass: "im-tag", class: _vm.tagClass }, [
        _c(
          "div",
          {
            staticClass: "content",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.check.apply(null, arguments)
              },
            },
          },
          [_c("div", { staticClass: "ellipsis" }, [_vm._t("default")], 2)]
        ),
        _vm._v(" "),
        _vm.closable
          ? _c(
              "div",
              {
                staticClass: "close",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.close.apply(null, arguments)
                  },
                },
              },
              [_c("span", { staticClass: "iconfont icon-close-light" })]
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }